var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5763 1.45076C11.8106 1.21645 12.1905 1.21645 12.4249 1.45076L16.9249 5.95076C17.1592 6.18507 17.1592 6.56497 16.9249 6.79929C16.6905 7.0336 16.3106 7.0336 16.0763 6.79929L12.6004 3.32336V13.125C12.6004 13.4564 12.3318 13.725 12.0004 13.725C11.669 13.725 11.4004 13.4564 11.4004 13.125V3.32375L7.92485 6.79929C7.69054 7.0336 7.31064 7.0336 7.07632 6.79929C6.84201 6.56497 6.84201 6.18507 7.07632 5.95076L11.5763 1.45076ZM4.12539 11.35C3.83544 11.35 3.60039 11.5851 3.60039 11.875V21C3.60039 21.29 3.83544 21.525 4.12539 21.525H19.8754C20.1653 21.525 20.4004 21.29 20.4004 21V11.875C20.4004 11.5851 20.1653 11.35 19.8754 11.35H17.6254C17.294 11.35 17.0254 11.0814 17.0254 10.75C17.0254 10.4187 17.294 10.15 17.6254 10.15H19.8754C20.8281 10.15 21.6004 10.9223 21.6004 11.875V21C21.6004 21.9527 20.8281 22.725 19.8754 22.725H4.12539C3.1727 22.725 2.40039 21.9527 2.40039 21V11.875C2.40039 10.9223 3.1727 10.15 4.12539 10.15H6.37539C6.70676 10.15 6.97539 10.4187 6.97539 10.75C6.97539 11.0814 6.70676 11.35 6.37539 11.35H4.12539Z",
    fill: "#101010"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.935466c1c55d9b1b9864c5d2b32d1b8c.svg";
export { ForwardRef as ReactComponent };